import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles(() => ({
  formControl: {
    marginLeft: 12,
    marginRight: 12,
  },
  select: {
    "& .MuiSelect-outlined": {
      paddingRight: 50,
    }
  },
  icon: {
    zIndex: 1,
    color: colors.black,
  },
}));

export default useStyles;
